var _circle, _path, _path2, _path3, _line, _path4, _path5, _path6, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 184,
    viewBox: "0 0 184 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 92,
    r: 92,
    fill: "#F2F7FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.602 93.8208V88.2518L108.071 90.7116C108.601 90.95 109.209 90.946 109.736 90.7007L115.304 88.1088V93.8208C115.304 96.0299 113.513 97.8208 111.304 97.8208L106.602 97.8208C104.392 97.8208 102.602 96.03 102.602 93.8208Z",
    stroke: "#EF437B",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.359 84.0165L110.809 79.3278C109.598 78.7893 108.215 78.7893 107.003 79.3278L96.4535 84.0165C95.8351 84.2914 95.8351 85.1691 96.4535 85.4439L107.003 90.1326C108.215 90.6711 109.598 90.6711 110.809 90.1326L121.359 85.4439C121.977 85.1691 121.977 84.2914 121.359 84.0165Z",
    stroke: "#EF437B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.701 102.645C103.019 102.533 103.345 102.43 103.678 102.335C104.219 102.181 104.797 102.346 105.193 102.734L107.758 105.243C108.39 105.861 109.422 105.861 110.054 105.243L112.619 102.734C113.015 102.346 113.594 102.181 114.134 102.335C118.663 103.623 121.823 106.535 121.823 109.92C121.823 111.645 120.377 113.044 118.594 113.044H106.378",
    stroke: "#EF437B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 96.2583,
    y1: 86.2302,
    x2: 96.2583,
    y2: 92.9931,
    stroke: "#EF437B",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9519 90.4931V80.29L80.412 83.4429C80.8625 83.6107 81.3584 83.6107 81.8089 83.4429L90.269 80.29V90.4932C90.269 92.7023 88.4782 94.4932 86.269 94.4932H75.9519C73.7427 94.4932 71.9519 92.7023 71.9519 90.4931Z",
    stroke: "#EF437B",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3636 73.7297L83.9003 66.8572C82.1243 66.0678 80.0969 66.0678 78.3209 66.8572L62.8576 73.7297C61.9511 74.1326 61.9511 75.4191 62.8576 75.822L78.3209 82.6946C80.0969 83.4839 82.1243 83.4839 83.9003 82.6946L99.3636 75.822C100.27 75.4191 100.27 74.1326 99.3636 73.7297Z",
    stroke: "#EF437B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6685 101.222L79.4279 104.9C80.3542 105.806 81.867 105.806 82.7933 104.9L86.5527 101.222C87.1335 100.654 87.9813 100.412 88.7737 100.637C95.4123 102.526 100.043 106.794 100.043 111.756C100.043 114.285 97.9243 116.335 95.3102 116.335H66.911C64.2969 116.335 62.1777 114.285 62.1777 111.756C62.1777 106.794 66.8089 102.526 73.4475 100.637C74.2399 100.412 75.0877 100.654 75.6685 101.222Z",
    stroke: "#EF437B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 64.0562,
    y1: 76.6378,
    x2: 64.0562,
    y2: 87.5863,
    stroke: "#EF437B",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/student.536c2f6140368e6c120ea1c93c738449.svg";
export { ForwardRef as ReactComponent };